module.exports = window["Wistia"]["Preact"];